import { useEffect, useState } from 'react'
import SelectableButton from 'atoms/SelectableButton'
import ColorPicker from 'molecules/ColorPicker'

type Props = {
  leftElement?: React.ReactNode
  rightElement?: React.ReactNode
  color: string
  onChangeColor: (color: string) => void
}

function ColorPickerButton({ leftElement, rightElement, color, onChangeColor }: Props) {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => (e.key === 'Enter' || e.key === 'Escape') && setOpen(false)

    document.addEventListener('keydown', handleKeyDown)

    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [])

  return (
    <div className='relative'>
      <SelectableButton isOpen={open} onClick={() => setOpen(!open)}>
        {leftElement}
        <div
          className='badge p-0 w-5 h-5 border-2 border-neutral'
          style={{
            backgroundColor: color
          }}
        />
        {rightElement}
      </SelectableButton>
      <ColorPicker
        color={color}
        isOpen={open}
        onChangeColor={color => onChangeColor(color)}
        onClose={() => setOpen(false)}
      />
    </div>
  )
}

export default ColorPickerButton
